import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthenticationStore } from "../../../../stores/auth";
import { useApiClient } from "../../../../api";
import GeneralLoading from "../../../../shared-components/Loading";

export default function SubscriptionRefresh() {
  const { updateUserInfo } = useAuthenticationStore();
  const ApiClient = useApiClient();
  const navigate = useNavigate();

  useEffect(() => {
    const resetUserSubscription = async () => {
      try {
        const response = await ApiClient.users.clearSubscriptionCache();
        if (response.success) {
          const userData = await ApiClient.users.me();
          updateUserInfo(userData);
        }
      } catch (error) {
        console.error("Failed to refresh subscription:", error);
      } finally {
        // redirect after refresh
        navigate("/account/home", { replace: true });
      }
    };

    resetUserSubscription();
  }, [ApiClient, updateUserInfo, navigate]);

  return <GeneralLoading />; // no UI needed, just performs action and redirects
}
